/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-08-03 13:59:43
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-08-03 14:00:13
 * @FilePath: \xm-runing-main\src\i18n\locales\lang\en\common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  确认: 'OK',
  取消: 'Cancel',
  okText: 'OK',
  closeText: 'Close',
  cancelText: 'Cancel',
  loadingText: 'Loading...',
  saveText: 'Save',
  delText: 'Delete',
  resetText: 'Reset',
  searchText: 'Search',
  queryText: 'Search',
  '个性化设置':'Person Setting',
  inputText: 'Please enter',
  chooseText: 'Please choose',
  '添加角色':'Add Role',
  mainPage: 'Home Page',

  redo: 'Refresh',
  back: 'Back',

  light: 'Light',
  dark: 'Dark',

  星期一:"Mon",
  星期二:"Tue",
  星期三:"Wed",
  星期四:"Thu",
  星期五:"Fri",
};
